import React, { useState, useEffect, useRef, useContext } from "react";

// Librerias de componentes
import { Toast } from "primereact/toast";

import CrudUnitModal from "./UnidadeMedidaModal/CrudUnitModal";
import {obtenerUnits} from "../../../API/Global/UnidadesMedida/UnitRequests"
import Card from "../../../Components/Card/Card";
import AgGrid from "../../../Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../Services/Config/ConfigService";
import { Button } from "primereact/button";
import { getLabel } from "../../../Services/Language/LanguageService";
import { baseLang } from "../../../Lang/BaseLang";
import { ConfigContext } from "../../../Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../Context/AuthContext/AuthContext";

export const UnitScreen = ( ) => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [unidades, setUnidades] = useState("");
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);

  const getInfo = async () => {
    setLoading(true);
    const r = await obtenerUnits();
    // console.log(r)
    setUnidades(r);
    setLoading(false);
  };

  useEffect(() => {
    window.document.title = "CSM • Unidades de Medida";
    getInfo();
  }, []);

  const colums = [
    {
      field: "IdUnit",
      header: "ID",
      headerEn: "ID",
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
      // hide: userAuth.IdRol !== 1
    },
    {
      field: "UnitName",
      header: "Unidad de Medida",
      headerEn: "Unit of measurement",
      className: "large",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "UnitSimbol",
      header: "Prefijo",
      headerEn: "Prefix",
      className: "small",
    },
    {
      field: "UnitDescription",
      header: "Descripción",
      headerEn: "Description",
      className: "large",
      flex: 1,
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "small",
      Format: "Estado",
      filter: false,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
    },
    {
      field: "IdUnit",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
          tooltipOptions: {
            position: "left",
          },
        },
      ],
    },
  ];

  const table = {
    Columns: colums,
    Data: unidades,
    loading: loading,
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "unidad", config.language));
  }, []);

  return (
    <div
      className=" p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "unidad", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              severity="success"
              onClick={() => {
                setShowDialog(true);
                setSelected(null);
              }}
            />
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />
      {showDialog && (
        <CrudUnitModal
          toastRef={toast}
          unidadesDialog={showDialog}
          unidad={selected}
          setUnidadesDialog={setShowDialog}
          getUnidades={getInfo}
          modo={selected ? "Editar" : "Crear"}
        />
      )}
    </div>
  );
};

export default UnitScreen;
